/**
 * Renderizador de Markdown do preview do Master.
 *
 * O corpo da campanha e MARKDOWN, nao HTML (decisao 6). O V2 renderiza com
 * react-markdown SEM rehype-raw, que ESCAPA tags cruas em vez de executa-las.
 * Este renderizador tem de se comportar igual, senao o autor ve no preview algo
 * diferente do que o cliente ve.
 *
 * Duas travas, e as duas importam:
 *  1) `html: false` — tag crua vira TEXTO. E o mesmo que o react-markdown faz
 *     sem rehype-raw. Sem isso, `<img src=x onerror=...>` viraria XSS no
 *     proprio Master.
 *  2) allow-list de href/src depois de renderizar: `javascript:` e `data:`
 *     viram inertes. O markdown-it ja bloqueia boa parte, mas a checagem e
 *     barata e o preview roda com a sessao do Master aberta.
 *
 * `linkify: false` e `typographer: false` para bater com o CommonMark puro do
 * react-markdown: sem isso o preview autolinkaria URLs que o cliente mostra
 * como texto.
 */

let renderer = null;

const getRenderer = () => {
  if (renderer) return renderer;
  if (typeof window === 'undefined' || !window.markdownit) return null;

  renderer = window.markdownit({
    html: false,
    linkify: false,
    typographer: false,
    breaks: true,
  });

  return renderer;
};

const escapeHtml = (text) =>
  String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

const SAFE_URL = /^(https?:\/\/|\/(?!\/)|#|mailto:)/i;

/**
 * Passa o HTML ja renderizado e neutraliza href/src fora da allow-list.
 * Feito no DOM em vez de por regex: regex sobre HTML erra em atributo com
 * aspas simples, entidade HTML e espaco antes dos dois-pontos.
 */
const sanitizeUrls = (html) => {
  if (typeof document === 'undefined') return html;

  const holder = document.createElement('div');
  holder.innerHTML = html;

  holder.querySelectorAll('[href]').forEach((node) => {
    if (!SAFE_URL.test(node.getAttribute('href') || '')) {
      node.removeAttribute('href');
    }
  });

  holder.querySelectorAll('[src]').forEach((node) => {
    if (!SAFE_URL.test(node.getAttribute('src') || '')) {
      node.removeAttribute('src');
    }
  });

  return holder.innerHTML;
};

/**
 * Devolve HTML pronto para `v-html` NO PREVIEW. Se o markdown-it nao carregou
 * (CDN fora do ar), degrada para texto escapado: fica legivel, nunca vira HTML
 * cru.
 */
export const renderBroadcastMarkdown = (markdown) => {
  const text = markdown || '';
  if (!text.trim()) return '';

  const md = getRenderer();
  if (!md) return '<p>' + escapeHtml(text).replace(/\n/g, '<br>') + '</p>';

  return sanitizeUrls(md.render(text));
};



// WEBPACK FOOTER //
// ./src/vue/pages/restricted/broadcast/broadcastMarkdown.js